<template>
  <div class="personal-data">
    <main v-if="dadosPaciente.Prontuario" class="container-sarah">
      <breadcrumb route="/inicio" :title="this.$t('areas.home')" />
      <b-tabs v-model="activeTab" class="view-desktop">
        <b-tab-item :label="this.$t('perfil.dados-gerais')">
          <DadosGerais :paciente="dadosPaciente" />
        </b-tab-item>
        <b-tab-item :label="this.$t('perfil.senha')">
          <Senha :paciente="dadosPaciente" />
        </b-tab-item>
        <b-tab-item
          v-if="dadosPaciente.TemResponsavel"
          :label="this.$t('perfil.responsavel')"
        >
          <tutor :data="dadosPaciente" />
        </b-tab-item>
        <b-tab-item :label="this.$t('perfil.endereco')">
          <Endereco :paciente="dadosPaciente" />
        </b-tab-item>
        <b-tab-item :label="this.$t('perfil.contato')">
          <Contato :paciente="dadosPaciente" />
        </b-tab-item>
      </b-tabs>
      <div class="view-mobile">
        <div class="form-template general-forms">
          <responsive-tab
            :data="optionData"
            v-model="option"
            @switchInfo="updateInfo($event)"
          />
          <div v-show="info === 'DadosGerais'">
            <DadosGerais :paciente="dadosPaciente" />
          </div>
          <div v-show="info === 'Senha'">
            <Senha :paciente="dadosPaciente" />
          </div>
          <div v-show="info === 'Tutor'">
            <tutor v-if="dadosPaciente.TemResponsavel" :data="dadosPaciente" />
          </div>
          <div v-show="info === 'Endereco'">
            <Endereco :paciente="dadosPaciente" />
          </div>
          <div v-show="info === 'Contato'">
            <Contato :paciente="dadosPaciente" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ResponsiveTab from '@/components/shared/tabs/ResponsiveTab'
import Breadcrumb from '../components/shared/breadcrumb/Breadcrumb'
import DadosGerais from '@/components/personal-data/DadosGerais'
import Tutor from '@/components/personal-data/Tutor'
import Endereco from '@/components/personal-data/Endereco'
import Contato from '@/components/personal-data/Contato'
import Senha from '@/components/personal-data/Senha'
import router from '@/router'
import {
  SET_DADOS_PACIENTE,
  UPDATE_DADOS_PACIENTE_ORIGINAIS
} from '@/store/modules/mutation-types'

export default {
  components: {
    ResponsiveTab,
    DadosGerais,
    Tutor,
    Endereco,
    Contato,
    Breadcrumb,
    Senha
  },
  computed: {
    ...mapGetters({
      dadosPaciente: 'dadosPaciente',
      dadosOriginais: 'dadosOriginais'
    })
  },
  data() {
    return {
      activeTab: 0,
      oldTab: 0,
      info: 'DadosGerais',
      option: 'Dados Gerais',
      optionData: [
        { label: this.$t('perfil.dados-gerais'), initial: 'DadosGerais' },
        { label: this.$t('perfil.senha'), initial: 'Senha' },
        { label: this.$t('perfil.endereco'), initial: 'Endereco' },
        { label: this.$t('perfil.contato'), initial: 'Contato' }
      ]
    }
  },
  methods: {
    ...mapMutations([SET_DADOS_PACIENTE, UPDATE_DADOS_PACIENTE_ORIGINAIS]),
    updateInfo(info) {
      this.info = info
    },
    returnPatient() {
      var temp = Object.assign({}, this.dadosOriginais)
      this.SET_DADOS_PACIENTE(temp)
    },
    VerificarUsuario() {
      if (this.dadosPaciente == null) {
        router.push('/')
      }
    }
  },
  beforeMount() {
    this.VerificarUsuario()
    this.UPDATE_DADOS_PACIENTE_ORIGINAIS(this.dadosPaciente)
    if (this.dadosPaciente.TemResponsavel) {
      this.optionData.splice(1, 0, {
        label: this.$t('perfil.responsavel'),
        initial: 'Tutor'
      })
    }
  },
  updated() {
    if (this.activeTab !== this.oldTab) {
      this.oldTab = this.activeTab
      this.returnPatient()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/tabs';
@import '~@/assets/stylesheets/buttons';
.personal-data {
  position: relative;

  .form-template.general-forms {
    .select-form .dropdown {
      margin: 2rem 0 3rem;
      .dropdown-trigger {
        width: 100%;
      }
      .dropdown-menu {
        width: 100%;
      }
    }
  }
}
.tabs ul {
  li {
    width: 33.33%;
    margin-bottom: 3.4375rem;
  }
}
h1 {
  font-size: 1.625rem;
  font-weight: $font-bold;

  margin: 2rem 0;
}
p {
  font-size: 1rem;
}
</style>
